var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHandHoldingGlobe = function SvgHandHoldingGlobe(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38,
    height: 38,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#10A2FC",
    clipPath: "url(#clip-path-holding-hand-globe)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m6.55 23.78-.71-.7 3.73-3.78c1.27-1.27 2.99-1.42 4.17-1.42a7.56 7.56 0 0 1 3.6.81h4.94c1.17 0 2.12.95 2.12 2.12 0 1.17-.77 2.45-2.45 2.45h-4.39v-1h4.39c1.38 0 1.45-1.21 1.45-1.45 0-.62-.5-1.12-1.12-1.12H17.1l-.11-.05a6.7 6.7 0 0 0-2.64-.74l-.62-.01c-1.59 0-2.69.36-3.46 1.13l-3.73 3.77.01-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13.62 30.67-.71-.71 1.59-1.59 10.06-1.56c.65-.27 6.95-2.94 9.72-5.05l.1-.09a1.28 1.28 0 1 0-1.51-2.05c-2.15 1.61-7.03 3.19-7.24 3.26-.17.03-2.47.38-3.68.38v-1c1.14 0 3.43-.35 3.45-.35 0 0 4.85-1.58 6.87-3.09a2.27 2.27 0 1 1 2.74 3.63l-.1.08c-3.03 2.31-9.73 5.1-10.02 5.22l-.11.03-9.79 1.52-1.36 1.36-.01.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11.88 34.7-.7-.71 2.19-2.2-8.47-8.46-2.19 2.19-.71-.71 2.9-2.9 9.88 9.88-2.9 2.91Zm11.6-31.2h-1v13.92h1V3.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.53 13.55H12.44v1h21.09v-1ZM22.98 9.91c-3.14 0-6-1.25-7.47-3.27l.81-.59c1.28 1.76 3.84 2.86 6.66 2.86 2.82 0 5.51-1.17 6.74-2.97l.83.56c-1.44 2.1-4.34 3.41-7.57 3.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m28.29 18.81-.97-.24c.35-1.41.53-2.93.53-4.52C27.85 8.61 25.62 4 22.98 4s-4.87 4.6-4.87 10.05c0 1 .07 1.99.22 2.94l-.99.15c-.15-1-.23-2.04-.23-3.09C17.11 7.86 19.69 3 22.98 3s5.87 4.85 5.87 11.05c0 1.67-.19 3.27-.56 4.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.22 16.51a11.05 11.05 0 1 1 21.52.01l-.97-.22a10.06 10.06 0 0 0-9.79-12.29 10.06 10.06 0 0 0-9.79 12.3l-.97.22v-.02Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-holding-hand-globe"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M2 3h33.92v31.7H2z"
  })))));
};
export default SvgHandHoldingGlobe;